import * as React from 'react';
import cn from 'classnames';
import Button, { ButtonFont, ButtonSize } from 'src/components/Button';
import styles from 'src/components/ImgButton/ImgButton.css';

interface IImgButtonProps {
  imgSrc: string;
  className?: string;
  disabled?: boolean;
  label?: string;
  title?: string;
  onClick?: (e: any) => void;
}

interface IImgButtonState {
  errorOnImageLoading: boolean;
}

class ImgButton extends React.Component<IImgButtonProps, IImgButtonState> {

  public state: IImgButtonState = {
    errorOnImageLoading: false,
  };

  private onImageLoadingError = () => {
    this.setState({ errorOnImageLoading: true });
  }

  public render() {
    const { className, disabled, imgSrc, label } = this.props;
    const { errorOnImageLoading } = this.state;
    const title = this.props.title || (imgSrc ? label : '');

    return (
      <Button
        btnSize={ButtonSize.MEDIUM}
        btnFont={ButtonFont.LIGHT}
        disabled={disabled}
        className={cn(styles.imgBtn, className)}
        title={title}
        onClick={this.props.onClick}
      >
        {
          imgSrc && !errorOnImageLoading
            ? <div className={styles.imgContainer}><img src={imgSrc} onError={this.onImageLoadingError} alt={label} /></div>
            : <span className={styles.title}>{label || ''}</span>
        }
        {this.props.children}
      </Button>
    );
  }
}

export default ImgButton;
